<template>
    <header
        class="land-page-header"
        :class="{ 'bg-transparent': isBackgroundTransparentActive }"
        :style="estiloHeader"
    >
        <template v-if="parceiroConfig.identificador == 'aq'">
            <div
                class="aq-partner-carousel"
                :style="estiloBannerCarousel"
                @mouseenter="pararBannerCarousel"
                @mouseleave="iniciarBannerCarousel"
            >
                <img
                    class="aq-partner-banner is-clickable"
                    :class="{ active: bannerAtivo === 0 }"
                    src="@/assets/images/parceiros/banner_copa_hapvida.jpeg"
                    alt="Copa Hapvida"
                    @click="enviarMensagemBannerHapvidaCopa()"
                >
                <img
                    class="aq-partner-banner"
                    :class="{ active: bannerAtivo === 1 }"
                    src="@/assets/images/parceiros/banner_ratinho_acerte_aqui.png"
                    alt="Ratinho Acerte Aqui"
                >

                <div class="aq-partner-carousel-dots">
                    <button
                        v-for="indice in 2"
                        :key="indice"
                        type="button"
                        :class="{ active: bannerAtivo === indice - 1 }"
                        :aria-label="`Exibir banner ${indice}`"
                        @click="selecionarBanner(indice - 1)"
                    ></button>
                </div>
            </div>
        </template>
        <template v-else-if="
                        ['aq', 'resolvaitapeva'].includes(parceiroConfig.identificador) &&
                        parceiroConfig.sessoes.partners.arquivos.length > 0
                    ">
            <simple-carousel
                :style="estiloLogo"
                style="right: 0"
                navigate-by-slide
                :autoplay="true"
                :autoplay-timeout="3000"
                :items-per-view="itemsPorPagina"
                :hide-buttons-on-start-end="true"
            >

                <img
                    style="margin: auto"
                    :src="parceiroConfig.sessoes.logoForBackgroundWhite.campos"
                />

                <img
                    v-for="(arquivo, i) in parceiroConfig.sessoes.partners.arquivos"
                    style="margin: auto; max-width: 18em"
                    :src="arquivo.arquivo"
                    :key="i"
                />
            </simple-carousel>
        </template>
        <template v-else>
            <div :style="estiloLogo" style="right: 0">
                <img
                    v-if="
                        parceiro &&
                        parceiroConfig.logo != null &&
                        parceiroConfig.identificador != 'mw' &&
                        !portalCamec
                    "
                    style="margin: auto"
                    :src="parceiroConfig.logo"
                />

                <img
                    v-else-if="
                        parceiroConfig.identificador == 'mw' || portalCamec
                    "
                    style="margin: auto"
                    :src="parceiroConfig.sessoes.logoForBackgroundWhite.campos"
                />

                <img
                    v-else
                    style="margin: auto"
                    src="@/assets/images/logo.png"
                    @click="$router.push({ name: 'LandPageParceiro' })"
                />

                <img
                    v-if="
                        portalCamec &&
                        parceiroConfig.sessoes.partners.arquivos[0] != null
                    "
                    style="margin: auto; max-width: 18em"
                    :src="parceiroConfig.sessoes.partners.arquivos[0].arquivo"
                />
            </div>
        </template>

        <menu
            v-if="
                parceiroConfig != null &&
                !portalCamec &&
                !['Senff'].includes(parceiroConfig.identificador)
            "
        >
            <ul>
                <li
                    v-if="parceiro == 'negocie'"
                    style="border-color: transparent"
                    :style="corBotaoCabecalho"
                    @click="$router.push({ name: 'WorkWithUs' })"
                >
                    Trabalhe Conosco
                </li>

                <li
                    style="border-color: transparent"
                    :style="corBotaoCabecalho"
                    @click="$router.push({ name: 'PrivacyPortal' })"
                >
                    Portal da privacidade
                </li>

                <li
                    v-if="
                        parceiro &&
                        parceiroConfig.sessoes.about &&
                        parceiroConfig.sessoes.about.campos
                    "
                    style="border-color: transparent"
                    :style="corBotaoCabecalho"
                    @click="goToSection('about')"
                >
                    Sobre
                </li>

                <li
                    v-if="
                        parceiro &&
                        parceiroConfig.sessoes.tutorial &&
                        parceiroConfig.sessoes.tutorial.campos
                    "
                    style="border-color: transparent"
                    :style="corBotaoCabecalho"
                    @click="goToSection('tutorial')"
                >
                    Como funciona
                </li>

                <li
                    v-if="
                        parceiro &&
                        parceiroConfig.sessoes.contact &&
                        parceiroConfig.sessoes.contact.campos
                    "
                    style="border-color: transparent"
                    :style="corBotaoCabecalho"
                    @click="goToSection('contact')"
                >
                    Contato
                </li>

                <li
                    v-if="parceiro && parceiroConfig.sessoes.creditor != null"
                    :style="corBotaoCabecalho"
                    @click="$router.push({ name: 'RegisterCreditor' })"
                >
                    Seja um credor parceiro
                </li>

                <li
                    v-if="
                        parceiroConfig.sessoes.customization == undefined
                            ? true
                            : parceiroConfig.sessoes.customization.campos
                                  .landPage.flgAcessoCredor
                    "
                    :style="corBotaoCabecalho"
                    @click="openAdmin()"
                >
                    Acesso credor
                </li>

                <li
                    v-if="
                        parceiroConfig.sessoes.customization == undefined
                            ? false
                            : parceiroConfig.sessoes.customization.campos
                                  .landPage.flgAtivarBotaoCadastroCredor
                    "
                    :style="corBotaoCabecalho"
                    @click="abrirTelaEnvioContatoCredor()"
                >
                    Seja nosso credor
                </li>
            </ul>

            <div
                v-if="parceiroConfig.identificador != 'mw'"
                class="btnIntegraRobo"
            >
                <small-button
                    v-if="
                        parceiroConfig.sessoes.customization.campos.landPage
                            .flgIntegraRobo
                    "
                    :icon="'fab fa-whatsapp'"
                    :title="'Fale com nosso atendimento'"
                    :color="color"
                    :botaoWhatsapp="true"
                    @click.native="connectWithBot()"
                ></small-button>
            </div>

            <div class="land-page-menu-mobile" :style="corBotaoCabecalho">
                <i class="fas fa-bars" @click="showMobile = true"></i>

                <div v-if="showMobile" class="menu-background-full">
                    <div style="display: flex; justify-content: flex-end">
                        <i class="fas fa-times" @click="showMobile = false"></i>
                    </div>

                    <div style="display: flex; justify-content: center">
                        <img
                            v-if="parceiro"
                            :src="parceiroConfig.sessoes.logoForBackgroundWhite"
                            alt="logo"
                            @click="$router.push({ name: 'LandPageParceiro' })"
                        />

                        <img
                            v-else
                            src="@/assets/images/logo.png"
                            alt="logo"
                            @click="$router.push({ name: 'LandPageParceiro' })"
                        />
                    </div>

                    <div style="display: flex; justify-content: center">
                        <ul
                            style="
                                display: flex;
                                flex-direction: column;
                                max-width: 200px;
                            "
                        >
                            <li
                                v-if="
                                    parceiro &&
                                    parceiroConfig.sessoes.about &&
                                    parceiroConfig.sessoes.about.campos &&
                                    !nokia
                                "
                                :style="corBotaoCabecalho"
                                @click="goToSection('about')"
                            >
                                Sobre
                            </li>

                            <li
                                v-if="
                                    parceiro &&
                                    parceiroConfig.sessoes.tutorial &&
                                    parceiroConfig.sessoes.tutorial.campos &&
                                    !nokia
                                "
                                :style="corBotaoCabecalho"
                                @click="goToSection('tutorial')"
                            >
                                Como funciona
                            </li>

                            <li
                                v-if="
                                    parceiro &&
                                    parceiroConfig.sessoes.contact &&
                                    parceiroConfig.sessoes.contact.campos &&
                                    !nokia
                                "
                                :style="corBotaoCabecalho"
                                @click="goToSection('contact')"
                            >
                                Contato
                            </li>

                            <li
                                v-if="
                                    parceiro &&
                                    parceiroConfig.sessoes.creditor != null
                                "
                                :style="corBotaoCabecalho"
                                @click="
                                    $router.push({
                                        name: 'RegisterCreditor',
                                    })
                                "
                            >
                                Seja um credor parceiro
                            </li>

                            <li
                                v-if="
                                    parceiroConfig.sessoes.customization ==
                                    undefined
                                        ? true
                                        : parceiroConfig.sessoes.customization
                                              .campos.landPage.flgAcessoCredor
                                "
                                :style="corBotaoCabecalho"
                                @click="openAdmin()"
                            >
                                Acesso credor
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </menu>
    </header>
</template>

<script>
import { mapState, createNamespacedHelpers } from "vuex";
import mixins from "@/mixins/mixins";

import Header from "@/components/Header";
import Template from "@/views/admin/Template";
import ButtonDefault from "@/components/buttons/ButtonDefault";
import ExpandingButton from "@/components/buttons/ExpandingButton.vue";
import SmallButton from "@/components/buttons/SmallButton.vue";
import SimpleCarousel from "vue2-simple-carousel";

const {
    mapActions: mapActionsPassosRetornarDividas,
} = createNamespacedHelpers("passosRetornarDividas");

export default {
    name: "LandPageHeader",

    components: {
        ButtonDefault,
        Template,
        Header,
        ExpandingButton,
        SmallButton,
        SimpleCarousel,
    },

    mixins: [mixins],

    props: {
        backgroundTransparent: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            showMobile: {
                type: Boolean,
                default: false,
            },

            nokia: {
                type: Boolean,
                default: window.innerWidth == 240,
            },

            color: {
                type: Object,
                default: {
                    "--color": "#FFF",
                    "--hoverColor": "#25D366",
                },
            },

            botaoWhatsapp: true,
            bannerAtivo: 0,
            bannerCarouselInterval: null,
        };
    },

    computed: {
        ...mapState({
            corPrimaria: (estado) => estado.corPrimaria,
            corSecundaria: (estado) => estado.corSecundaria,
            portalCamec: (estado) => estado.portalCamec,
        }),

        isBackgroundTransparentActive() {
            return this.backgroundTransparent == undefined
                ? this.parceiro
                : this.backgroundTransparent;
        },

        estiloBannerCarousel() {
            return {
                "background-color": this.bannerAtivo === 0
                    ? "#04102a"
                    : "#cdebe4",
            };
        },

        corBotaoCabecalho() {
            if (this.parceiroConfig.identificador == "aq") {
                return {
                    "background-color": "#404040",
                    "color": "#eee",
                    "border": "2px solid #fff",
                }
            } else {
                return (
                    this.corPrimaria,
                    {
                        color: this.checkColors("headerButtonsColor")
                        ? this.parceiroConfig.sessoes.header.campos
                        .headerButtonsColor
                        : "#FFF",
                    }
                );
            }
        },

        estiloLogo() {
            let estiloPosicionamentoLogo =
                window.innerWidth > 700
                    ? { display: "flex" }
                    : { margin: "auto" };

            if (
                ["350"].includes(this.parceiroConfig.emp_codigo) ||
                this.parceiroConfig.identificador == "aq"
            ) {
                estiloPosicionamentoLogo = { display: "flex", "background-color": "#FFF"};
            }

            return {
                "--imgMaxWidth": this.parceiroConfig.sessoes.customization
                    .campos.landPage.flgMaxWidth
                    ? "25em"
                    : "13em",
                ...estiloPosicionamentoLogo,
            };
        },

        estiloHeader() {
            if (
                ["350"].includes(this.parceiroConfig.emp_codigo) ||
                this.parceiroConfig.identificador == "aq"
            ) {
                return {
                    "margin-top": "0px",
                    "background-color": "#FFF",
                    height: this.parceiroConfig.sessoes.customization.campos
                        .landPage.flgMaxWidth
                        ? "180px"
                        : "120px",
                    ...this.corPrimaria,
                    display: "flex",
                    "flex-direction": "column"
                };
            } else if (this.parceiroConfig.emp_codigo == 128) {
                return {
                    display: "flex",
                    "justify-content": "center",
                };
            } else {
                return this.corPrimaria;
            }
        },

        itemsPorPagina() {
            if (window.innerWidth > 1400) {
                return 5;
            } else if (window.innerWidth > 1000) {
                return 3;
            } else {
                return 1;
            }
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
            this.iniciarBannerCarousel();
        });
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
        this.pararBannerCarousel();
    },

    methods: {
        ...mapActionsPassosRetornarDividas(["action_click_banner_hapvida"]),

        iniciarBannerCarousel() {
            if (
                this.parceiroConfig.identificador != "aq" ||
                this.bannerCarouselInterval
            ) {
                return;
            }

            this.bannerCarouselInterval = window.setInterval(() => {
                this.bannerAtivo = (this.bannerAtivo + 1) % 2;
            }, 5000);
        },

        pararBannerCarousel() {
            window.clearInterval(this.bannerCarouselInterval);
            this.bannerCarouselInterval = null;
        },

        selecionarBanner(indice) {
            this.bannerAtivo = indice;
            this.pararBannerCarousel();
            this.iniciarBannerCarousel();
        },

        openAdmin() {
            window.open("https://app.aquicob.com.br/", "_blank");
        },

        goToSection(section) {
            if (this.$route.name !== "LandPageParceiro") {
                this.$router.push({ name: "LandPageParceiro" });
            } else {
                var element = this.$parent.$parent.$refs[section];
                var top = element.offsetTop;
                element.scrollIntoView({ behavior: "smooth", top });
                this.showMobile = false;
            }
        },

        onResize() {
            this.nokia = window.innerWidth == 240;
        },

        connectWithBot() {
            if (this.parceiroConfig.sessoes.contact.campos.whatsapp) {
                let janela = window.open(
                    `https://api.whatsapp.com/send?phone=55${this.removeMaskCharacters(
                        this.parceiroConfig.sessoes.contact.campos.whatsapp
                    )}
											&text=Olá estou vindo do portal ${this.parceiro.toUpperCase()}.`,
                    "_blank"
                );
                janela.focus();
            } else {
                this.CHANGE_MESSAGE_MODAL({
                    show: true,
                    title: "Ocorreu um erro",
                    message:
                        "Não foi possível encontrar o número de Whatsapp da assessoria! ",
                    styleMessage: "danger",
                });
            }
        },

        enviarMensagemBannerHapvidaCopa() {
            const janela = window.open(
                `https://api.whatsapp.com/send?phone=5508007779070&text=Olá! Gostaria de informações sobre os planos da Hapvida em parceria com Acerte Aqui. Anúncio: 2181`,
                "_blank"
            );
            janela.focus();

            this.action_click_banner_hapvida();
        },

        checkColors(configuracaoCampo) {
            return (
                this.parceiro &&
                this.parceiroConfig.sessoes.header.campos &&
                this.parceiroConfig.sessoes.header.campos[configuracaoCampo]
            );
        },

        abrirTelaEnvioContatoCredor() {
            this.$router.push(
                {
                    name: 'CadastrarNovoCredor',
                    query: {
                        "tipo-contato": "C"
                    }
                }
            );
        },
    },
};
</script>

<style scoped lang="scss">
.land-page-header {
    background: var(--lightGrayColor);
    display: flex;
    justify-content: space-around;
    margin-top: 25px;

    img {
        margin-top: 20px;
        max-width: var(--imgMaxWidth);
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
    }

    .aq-partner-carousel {
        position: relative;
        flex: 0 0 110px;
        width: 100%;
        min-height: 110px;
        height: 110px;
        overflow: hidden;
        transition: background-color 900ms ease-in-out;

        .aq-partner-banner {
            position: absolute;
            top: 0;
            left: 50%;
            height: 100%;
            width: 100%;
            margin-top: 0;
            max-width: 550px;
            object-fit: contain;
            opacity: 0;
            transform: translateX(-50%);
            transition: opacity 900ms ease-in-out;
            pointer-events: none;
            cursor: default;

            &.active {
                opacity: 1;
                pointer-events: auto;
            }

            &.is-clickable {
                cursor: pointer;
            }
        }

        .aq-partner-carousel-dots {
            position: absolute;
            z-index: 1;
            bottom: 5px;
            left: 50%;
            display: flex;
            gap: 6px;
            transform: translateX(-50%);

            button {
                width: 8px;
                height: 8px;
                padding: 0;
                border: 1px solid rgba(255, 255, 255, 0.9);
                border-radius: 50%;
                background-color: rgba(0, 0, 0, 0.3);
                cursor: pointer;
                transition: background-color 300ms ease-in-out;

                &.active {
                    background-color: #fff;
                }
            }
        }
    }

    menu {
        ul {
            display: flex;
            gap: 20px;
            justify-content: flex-end;
            margin-top: 50px;

            li {
                display: inline-block;
                font-size: 18px;
                font-family: "Roboto-Bold", sans-serif;
                cursor: pointer;
                padding: 15px;
                width: fit-content;
                height: fit-content;
                border-radius: 27px;
                transition: all 0.2s ease-in-out;
                border: 2px solid var(--whiteColor);

                &:hover {
                    background-color: var(--color);
                    color: var(--whiteColor);
                    transition: all 0.2s ease-in-out;
                    border: 2px solid transparent;
                }

                @media only screen and (max-width: 1245px) {
                    width: 110%;
                    margin-bottom: 15px;
                    display: flex;
                    justify-content: center;
                    padding: 12px;
                    font-size: 18px;
                    font-family: "Roboto-Bold", sans-serif;
                    color: var(--color);
                    cursor: pointer;
                    border: 2px solid var(--color);

                    a {
                        font-size: 32px;
                        color: var(--color);
                        font-family: Cabin;
                        text-align: center;
                    }
                }

                @media only screen and (max-width: 768px) {
                    width: 100%;
                    margin-bottom: 10px;
                }

                @media only screen and (max-width: 414px) {
                    margin-bottom: 10px;
                }

                @media only screen and (max-width: 240px) {
                    width: 90%;
                    font-size: 15px;
                    margin: 0px;
                }
            }

            @media only screen and (max-width: 1245px) {
                display: none;
            }

            @media only screen and (max-width: 240px) {
                justify-content: center;
                gap: 20;
                margin: 0px;
            }
        }

        @media (max-width: 1245px) {
            display: none;
        }

        @media (max-width: 700px) {
            position: absolute;
            right: 20px;
        }
    }
}

.land-page-menu-mobile {
    display: none;
    align-content: center;
    justify-content: end;

    i {
        font-size: 32px;
        color: var(--whiteColor);
        cursor: pointer;
    }
}

.bg-transparent {
    background: transparent !important;
}

.menu-background-full {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: var(--whiteColor);
    display: flex;
    flex-direction: column;
    z-index: 900;

    @media only screen and (max-width: 240px) {
        justify-content: flex-start;
        height: 200vh;
    }

    img {
        margin-bottom: 35px;

        @media only screen and (max-width: 450px) {
            height: 20vh;
            margin-bottom: 20px;
        }

        @media only screen and (max-width: 240px) {
            width: 50%;
            margin-right: 15px;
        }
    }

    i {
        font-size: 38px;
        color: var(--color);
        justify-self: end;
        top: -10;

        @media only screen and (max-width: 240px) {
            right: 15vw;
            font-size: 20px;
        }
    }
}

.btnIntegraRobo {
    align-self: end;
    margin: 0 8% 10px 0;
    display: none;

    @media screen and (max-width: 700px) {
        display: flex;
    }
}
</style>
